import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useChatContext } from 'stream-chat-react'
import { getChannel } from './ChannelList/utils'

// Opens the channel referenced by ?cid= (e.g. /chat?cid=messaging:abc, used
// by the links in Slack inbox threads, and on a phone by the open thread).
// A channel already open, as a tap on the list leaves it, isn't read again.
// Renders nothing.
const DeepLink = () => {
  const { client, setActiveChannel, channel: activeChannel } = useChatContext()
  const [searchParams] = useSearchParams()
  const cid = searchParams.get('cid')
  const activeCid = useRef()
  activeCid.current = activeChannel?.cid

  useEffect(() => {
    if (!cid || cid === activeCid.current) return

    let cancelled = false

    const openChannel = async () => {
      try {
        const channel = await getChannel(client, cid)
        if (channel && !cancelled) setActiveChannel(channel)
      } catch (e) {
        console.log('error opening deep-linked channel', cid, e)
      }
    }

    openChannel()

    return () => {
      cancelled = true
    }
  }, [client, cid, setActiveChannel])

  return null
}

export default DeepLink
